import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import finishImage from './media/finish.svg';
import pendingImage from './media/pending.svg';
import successImage from './media/success.svg';

import styles from './ProgressCard.module.scss';

const ProgressCard: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.progressCard, props.className)}>
            <div className={styles.line}/>
            <div className={styles.step}>
                <img
                    className={styles.image}
                    src={successImage}
                    alt={'Finish'}
                />
                <div className={styles.title}>
                    Transaction submitted
                </div>
            </div>
            <div className={styles.step}>
                <img
                    className={styles.image}
                    src={pendingImage}
                    alt={'Pending'}
                />
                <div>
                    <div className={styles.title}>
                        Matching payment
                    </div>
                    <div className={styles.description}>
                        5–10 minutes
                    </div>
                </div>
            </div>
            <div className={styles.step}>
                <img
                    className={styles.image}
                    src={finishImage}
                    alt={'Success'}
                />
                <div className={classNames(styles.title, styles.finishTitle)}>
                    Merchant confirmation
                </div>
            </div>
        </div>
    );
};

export default ProgressCard;
